import axios from '@/axios'

const state = {
  collectionSingle: undefined,
  error: undefined,
  loading: false,
  users: []
};
const actions = {
  async save({commit}, payload) {
    try {
      commit('LOADING', true);
      await axios.put(`admin/adv/${payload.id}`,{data:payload.data,op:'update'})
      commit('INIT', payload);
      this.$ntSet();
    } catch (e) {
      console.log('error has')
      commit('ERROR', e);
    } finally {
      commit('LOADING', false);
    }
  },
  async advId({commit}, id) {
    try {
      commit('LOADING', true);
      let res = await axios.get('admin/adv/' + id);
      console.log(res.data, 'res-attr')
      commit('ADV_ID', res.data);
    } catch (e) {
      commit('ERROR', e);
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },

};
const mutations = {
  UPDATE_ADV(state, payload) {
    state.advEdit = state.advEdit.map(adv => {
      if (adv.id === payload.id) {
        return Object.assign({}, adv, payload.data)
      }
      return adv
    })
    console.log(state.adv, 'users data kole')
  },


  LOADING(state, payload) {
    state.loading = payload;
  },
  ADV_ID(state, payload) {
    state.collectionSingle = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
